import { render, staticRenderFns } from "./RawMaterials.vue?vue&type=template&id=3403af46&scoped=true"
import script from "./RawMaterials.vue?vue&type=script&lang=js"
export * from "./RawMaterials.vue?vue&type=script&lang=js"
import style0 from "./RawMaterials.vue?vue&type=style&index=0&id=3403af46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403af46",
  null
  
)

export default component.exports